import { InvoiceKind, InvoiceSubkind, ChargeState, QueryCompanyArgs } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"
import { gql } from "../../../gql"

const QUERY = gql(`
  query StaffInvoicingBadDebtCompanyUnpaidInvoices(
    $companyId: ID!
    $onlyKind: InvoiceKind
    $subkinds: [InvoiceSubkind!]
    $chargeStates: [ChargeState!]
  ) {
    company(companyId: $companyId) {
      id
      customer {
        id
        name
        unpaidInvoicesAmount(
          onlyKind: $onlyKind
          subkinds: $subkinds
          chargeStates: $chargeStates
          queryType: UNPAID_OVERDUE
        ) {
          averageDueDays
          totalCount
          totalAmount {
            formatted
          }
        }
        paymentsSettings {
          restricted
          flaggedAsFraudster
          badDebtCategory
        }
      }
    }
  }
`)

export const useCompanyRestrictionsQuery = (variables: QueryCompanyArgs) =>
  useQuery(QUERY, {
    skip: !variables.companyId,
    variables: {
      ...variables,
      onlyKind: InvoiceKind.Oyster,
      chargeStates: [
        ChargeState.Pending,
        ChargeState.ManualProcessNotPaid,
        ChargeState.ChargedBack,
        ChargeState.AutomatedProcessInProgress,
        ChargeState.AutomatedProcessFailed,
        ChargeState.AutomatedProcessConfirmed,
        ChargeState.Overdue,
        ChargeState.PartiallyPaid,
      ],
      subkinds: [
        InvoiceSubkind.OysterPrefunding,
        InvoiceSubkind.OysterSettlement,
        InvoiceSubkind.OysterDeposit,
        InvoiceSubkind.OysterScale,
        InvoiceSubkind.OysterManualInvoice,
      ],
    },
  })
